import { createNamedContext } from '@utils';
import { PostDeleteContextValue, PostDeleteTogglePromptContextValue } from './interfaces';

export const PostDeleteTogglePromptContext = createNamedContext<PostDeleteTogglePromptContextValue>(undefined, 'Posts.Delete.TogglePrompt.Context');

export const PostDeleteContext = createNamedContext<PostDeleteContextValue>(undefined, 'Posts.Delete.Context');